import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TaskSelectorModel, TaskSelectorWithInstructionsModel} from "web-shared";
import {MasterOperationModel} from "web-shared";
import {IntegratedMasterService} from "../services/integrated-master.service";
import {TaskSelectorEditModalComponent} from "../task-selector-edit-modal/task-selector-edit-modal.component";
import {takeUntil} from "rxjs/operators";
import {instanceToInstance} from "class-transformer";
import {BaseComponent, LeModalService} from "common-shared";
import {CopyPasteService} from "web-shared";

@Component({
  selector: 'ime-task-selector-cell',
  templateUrl: './task-selector-cell.component.html',
  styles: [
  ]
})
export class TaskSelectorCellComponent extends BaseComponent implements OnInit {
  @Input() taskSelector: TaskSelectorModel;
  @Input() masterOperation: MasterOperationModel;
  @Input() readonly: boolean = false;
  @Output() changed = new EventEmitter<TaskSelectorModel>();

  constructor(protected integratedMasterService: IntegratedMasterService, private modalService: LeModalService, private copyPasteService: CopyPasteService) {
    super();
  }

  ngOnInit(): void {
  }

  editTaskSelector() {
    this.modalService.show(TaskSelectorEditModalComponent, {initialState: {taskSelector: this.taskSelector, mode: "edit", readonly: this.readonly}, class: 'modal-xl'})
      .onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
      if (value?.data) {
        let ts = value.data as TaskSelectorModel;
        if (['delete', 'deleteWithInstructions'].includes(value.result)) {
          this.integratedMasterService.removeTaskSelectorFromOperation(this.masterOperation, ts, value.result as 'delete' | 'deleteWithInstructions');
        }
        this.taskSelector.ValidCondition = instanceToInstance(this.taskSelector.ValidCondition);
        this.changed.emit();
        return value;
      }
    });
  }

  copy(all: boolean = false) {
    const taskSelectorsWithInstructions: TaskSelectorWithInstructionsModel[] = [];
    if (all) {
      this.masterOperation.TaskSelectors.forEach(ts => {
        taskSelectorsWithInstructions.push(TaskSelectorWithInstructionsModel.convertTo(ts, this.masterOperation));
      });
    } else {
      taskSelectorsWithInstructions.push(TaskSelectorWithInstructionsModel.convertTo(this.taskSelector, this.masterOperation));
    }
    this.copyPasteService.copy('TaskSelector', taskSelectorsWithInstructions);
  }

  paste(masterOperation: MasterOperationModel, fromClipboard: boolean = false) {
    this.copyPasteService.paste('TaskSelector', masterOperation, null, null, fromClipboard).then(() => {
      this.changed.emit();
    });
  }
}
